import React from 'react';
import { LuFlagTriangleRight } from "react-icons/lu";
import {
  Bar,
  BarChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell
} from 'recharts';

interface HorizontalBarChartProps {
  day1Forecast: number;
  day2Forecast: number;
}

const HorizontalBarChart: React.FC<HorizontalBarChartProps> = ({ day1Forecast, day2Forecast }) => {
  const data = [
    { day: 'Day 1', value: day1Forecast },
    { day: 'Day 2', value: day2Forecast },
  ];

  const maxValue = Math.max(day1Forecast, day2Forecast);
  const roundedMax = Math.ceil(maxValue / 10) * 10;
  const rawTicks = [0,roundedMax/2,roundedMax];
  const uniqueTicks = Array.from(new Set(rawTicks));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} className='flex'>
      {/* Title */}
      <div className='flex font-poppins'>
        <LuFlagTriangleRight className='text-[10px]' />
        <p className='flex text-[8px] text-grey-100'>Forecast: {day1Forecast} MW</p>
      </div>

      <BarChart
        width={180}
        height={100}
        data={data}
        layout="vertical"
        margin={{ top: 10, right: 30, left: 10, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" horizontal={false} />
        <XAxis
  type="number"
  domain={[0, roundedMax]}
  ticks={uniqueTicks}
  tick={{ fontSize: 8 }}
  stroke="#585858"
/>
        <YAxis
          type="category"
          dataKey="day"
          tick={{ fontSize: 8 }}
          axisLine={false}
          tickLine={false}
          stroke="#585858"
        />
        <Tooltip cursor={{ fill: 'rgba(0,0,0,0.1)' }} />
        <Bar dataKey="value" barSize={22}>
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={entry.day === 'Day 1' ? '#64748b' : '#B4C6DF'}
            />
          ))}
        </Bar>
      </BarChart>
    </div>
  );
};

export default HorizontalBarChart;
